export enum EntityViewDisplay {
    /**
     * Attachment-tile body (File entity). Same board shell as Table/List/Card — only the body host
     * differs (`board-attachments`). Not a separate files product.
     */
    Attachments = 'Attachments',
    Board = 'Board',
    Calendar = 'Calendar',
    Gantt = 'Gantt',
    Card = 'Card',
    /** Card rail + document preview pane. Successor of ListDetail — the v2 board treats a persisted
     *  ListDetail as CardDetail. */
    CardDetail = 'CardDetail',
    Kanban = 'Kanban',
    List = 'List',
    /** Legacy master-detail (v1 entity.dashboard). Superseded by CardDetail for new views. */
    ListDetail = 'ListDetail',
    Table = 'Table',
    /** Table + document preview pane in a 50/50 split. */
    TableDetail = 'TableDetail',
    TreeList = 'TreeList',
}

export enum EntityViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum EntityViewSortDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

export enum EntityViewType {
    System = 'System',
    Embedded = 'Embedded',
    User = 'User',
    Template = 'Template'
}

export enum EntityAdvancedFilterOperator {
  Equals = 'equals',
  NotEquals = 'notEquals',
  In = 'in',
  NotIn = 'notIn',
  Contains = 'contains',
  NotContains = 'notContains',
  StartsWith = 'startsWith',
  EndsWith = 'endsWith',
  GreaterThan = 'greaterThan',
  GreaterThanOrEqual = 'greaterThanOrEqual',
  LessThan = 'lessThan',
  LessThanOrEqual = 'lessThanOrEqual',
  Between = 'between',
  On = 'on',
  Before = 'before',
  After = 'after',
  OnOrBefore = 'onOrBefore',
  OnOrAfter = 'onOrAfter',
  RelativeDate = 'relativeDate',
  IsEmpty = 'isEmpty',
  IsNotEmpty = 'isNotEmpty',
}

/**
 * Concrete calendar layouts a Calendar board can open in. Values are the serialised view ids stored
 * on `EntityView.calendar.view`; the FullCalendar host maps them to plugin view names so jms-model
 * carries no FullCalendar types. Resource-prefixed members need a resource axis
 * (`EntityViewCalendar.resources`); the host falls back to the non-resource twin when none is set.
 */
export enum EntityCalendarView {
  ListWeek = 'listWeek',
  ListMonth = 'listMonth',
  DayGridMonth = 'dayGridMonth',
  DayGridWeek = 'dayGridWeek',
  ResourceDayGridDay = 'resourceDayGridDay',
  ResourceDayGridWeek = 'resourceDayGridWeek',
  ResourceTimeGridDay = 'resourceTimeGridDay',
  ResourceTimeGridWeek = 'resourceTimeGridWeek',
  ResourceTimelineDay = 'resourceTimelineDay',
  ResourceTimelineWeek = 'resourceTimelineWeek',
  TimeGridDay = 'timeGridDay',
  TimeGridWeek = 'timeGridWeek',
}

/** Resource axis direction for timeline-style calendar views (legacy AllocationViewOrientation). */
export enum EntityCalendarOrientation {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

/** Resource lanes a calendar view may show. Mirrors the legacy per-type constraints minus stored rosters. */
export enum EntityCalendarResourceType {
  Contractor = 'Contractor',
  Employee = 'Employee',
  Equipment = 'Equipment',
  Unassigned = 'Unassigned',
}
